import React, { useState } from "react";
import PropTypes from "prop-types";

import { alpha, withStyles, makeStyles } from "@material-ui/core/styles";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";

import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles((theme) => ({
	formController: {
		margin: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			margin: 0,
		},
	},
}));

const BootstrapInput = withStyles((theme) => ({
	root: {
		"label + &": {
			marginTop: theme.spacing(2.5),
		},
	},
	input: {
		borderRadius: 10,
		position: "relative",
		textAlign: "left",
		backgroundColor: theme.palette.common.white,
		border: "1px solid #ced4da",
		fontSize: 16,
		width: "100%",
		padding: "10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:focus": {
			boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
			borderColor: theme.palette.primary.main,
			borderRadius: 10,
		},
	},
}))(InputBase);

export default function SelectBox({
	label,
	onChange,
	defaultValue,
	classes,
	values,
}) {
	const _classes = useStyles();
	const [currValue, setCurrValue] = useState(defaultValue || "None");
	const handleChange = (event) => {
		setCurrValue(event.target.value);
		onChange(event);
	};

	const generateMenuList = (items) => {
		return items.map((item, index) => (
			<MenuItem key={index} value={item.value}>
				{item.name}
			</MenuItem>
		));
	};

	return (
		<FormControl
			className={`${_classes.formController} ${classes.cSelectBoxContainer}`}
		>
			<InputLabel className={classes.cSelectBoxLabel} shrink id={`${label}_id`}>
				{label}
			</InputLabel>
			<Select
				labelId={`${label}_id`}
				className={classes.cSelectBox}
				id={`${label}_select_id`}
				value={currValue}
				onChange={handleChange}
				input={<BootstrapInput className={classes.cInputBox} />}
			>
				{generateMenuList(values)}
			</Select>
		</FormControl>
	);
}

SelectBox.propTypes = {
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	defaultValue: PropTypes.any,
	classes: PropTypes.shape({
		cSelectBoxLabel: PropTypes.object,
		cSelectBox: PropTypes.object,
		cInputBox: PropTypes.object,
		cSelectBoxContainer: PropTypes.object,
	}),
	values: PropTypes.array.isRequired,
};
SelectBox.defaultProps = {
	onChange: () => {},
	defaultValue: " ",
	classes: {},
};
